import { ScreenNames } from '@hrms/common/routes/screens';
import { ComponentsMap } from '@hrms/common/routes/components';
import { RouteConstantsInterface } from '@hrms/common/constant/types';
import { ModuleRoutesComponentInterface } from '@hrms/common/routes/types';
import { ModuleConstants } from '@hrms/common/constant/modules';
import { generateImage } from '@hrms/common/utils/generateImage';

export enum RouteConstantEnums {
  BULK_REGULARIZATION,
  BULK_USER_CREATION,
  BULK_GRACE_ATTENDANCE,
}

const BULK_UPLOAD_BASE_URL = '/bulk-upload';

export const RouteConstants: RouteConstantsInterface = {
  BULK_UPLOAD: BULK_UPLOAD_BASE_URL,
  BULK_REGULARIZATION: `${BULK_UPLOAD_BASE_URL}/regularisation`,
  BULK_USER_CREATION: `${BULK_UPLOAD_BASE_URL}/user`,
  BULK_GRACE_ATTENDANCE: `${BULK_UPLOAD_BASE_URL}/grace-attendance`,
  BULK_ROLE_UPDATE: `${BULK_UPLOAD_BASE_URL}/role-update`,
};

const getBulkCreationModuleRoutes: ModuleRoutesComponentInterface = () => [
  {
    id: ModuleConstants.BULK_UPLOAD,
    route: RouteConstants.BULK_UPLOAD,
    title: ScreenNames.BULK_UPLOAD,
    component: null,
    icon: generateImage({
      noScale: true,
      name: 'clock-plus',
      alt: 'clock-plus',
      className: 'w-4 h-4',
    }),
    children: [
      {
        id: ModuleConstants.BULK_REGULARIZATION,
        route: RouteConstants.BULK_REGULARIZATION,
        title: ScreenNames.BULK_REGULARIZATION,
        component: ComponentsMap.BULK_REGULARISATION,
      },
      {
        id: ModuleConstants.BULK_USER_UPLOAD,
        route: RouteConstants.BULK_USER_CREATION,
        title: ScreenNames.BULK_USER,
        component: ComponentsMap.BULK_USER_CREATION,
      },
      {
        id: ModuleConstants.BULK_GRACE_ATTENDANCE,
        route: RouteConstants.BULK_GRACE_ATTENDANCE,
        title: ScreenNames.BULK_GRACE_ATTENDANCE,
        component: ComponentsMap.BULK_GRACE_ATTENDANCE,
      },
      {
        id: ModuleConstants.BULK_ROLE_UPDATE,
        route: RouteConstants.BULK_ROLE_UPDATE,
        title: ScreenNames.BULK_ROLE_UPDATE,
        component: ComponentsMap.BULK_ROLE_UPDATE,
      },
    ],
  },
];

export { getBulkCreationModuleRoutes };
